import React from 'react';
import { PageTopBreadcrumb } from '../../../core/components/types';
import PageTop from '../../../core/components/PageTop';
import { ROUTE_LIST } from '../payor_const';
import { usePayorEditInit } from './pagehooks/usePayorEditInit';
import { usePayorEditStore } from './pagehooks/usePayorEditStore';
import PayorEditForm from './form/PayorEditForm';

const PageAdminPayorEdit = (): JSX.Element => {
    const pageTitle = usePayorEditInit();
    const breadcrumb: PageTopBreadcrumb = {
        title: 'Return to Excluded Payor List',
        icon: 'sprite-list',
        route: ROUTE_LIST,
    };

    return (
        <>
            <PageTop
                title={pageTitle}
                icon="sprite-payor"
                breadcrumb={breadcrumb}
            />
            <div className="payor-feature payor-edit">
                <Content />
            </div>
        </>
    );
};

const Content = (): JSX.Element => {
    const { state } = usePayorEditStore();

    // wait for init
    if (state.init) {
        return <></>;
    }

    return (
        <section className="panel">
            <PayorEditForm />
        </section>
    );
};

export default PageAdminPayorEdit;
